// What the layout editor says about a layout (backfill PR 32): the keycap profiles its rows
// use (LayoutEditScreen, for the transfer film quantities) and the label the editor names the
// CNC download by and the product editor shows in its layout select (one copy each: the
// editor's read its state, the product editor's a layout document; both pass the fields now).
export const getProfilesFromLayout = (layout) => {
  const profiles = new Set(); // use a Set, so every profile is only stored once

  layout.flat().forEach((keycap) => {
    // go through every keycap in the layout:
    if (keycap.isSpacer || !keycap.profiles) return; // skip spacers and keycaps without profiles (the rows hold no empty objects, as the validator refuses them: the guard for them went in PR 32)

    Object.keys(keycap.profiles).forEach((profile) => {
      // go through all profiles of the current keycap:
      profiles.add(profile); // store the current profile
    });
  });

  return [...profiles]; // convert the Set back to an array
}; // gets all profiles that are used by the current layout

export function formatLayoutLabel({ layoutName, size, tags, numOfKeycaps }) {
  const parts = [];

  // size (optional)
  if (size && size !== 'Others') {
    parts.push(size.split(' ')[0]);
  }

  // tags (optional)
  const tagList = Array.isArray(tags) ? tags : [];
  if (tagList.length > 0) {
    parts.push(tagList.join(', '));
  }

  // key count (always shown)
  parts.push(`${numOfKeycaps}-Key`);

  return `${layoutName} [${parts.join(', ')}]`;
} // the layout's label: its name, then the size's first word, its tags and its key count in brackets
